/**
 *
 * Asynchronously loads the component for BehaviouralAssessmentsQuiz
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/BehaviouralAssessmentsQuiz/loadable.js